<template>
  <div class="animated fadeIn" id="tab-mouvements">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Mouvements BRED</strong>
        <vue-excel-xlsx
          :data="excelData"
          :columns="excelColumns"
          class="btn btn-success mr-1 pull-right"
          filename="exporter_mouvements">
          <i class="fa fa-file-excel-o"></i>&nbsp; Exporter en Excel
        </vue-excel-xlsx>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div v-if="props.row.timestamp" slot="timestamp" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.timestamp) }}</span>
          </div>
          <div slot="numero_operation" slot-scope="props" class="slot-number">{{ props.row.numero_operation }}</div>
          <div slot="operation" slot-scope="props">{{ props.row.operation }}</div>


          <div v-if="props.row.montant < 0" slot="montant" slot-scope="props" class="slot-number text-nowrap montant-negatif">{{ formatNumber(props.row.montant) }}</div>
          <div v-else slot="montant" slot-scope="props" class="slot-number" nowrap>{{ formatNumber(props.row.montant) }}</div>

          <div slot="nom_client" slot-scope="props">{{ props.row.nom_client }}</div>
          <div slot="libelle" slot-scope="props">{{ props.row.libelle }}</div>
          <div slot="commentaire" slot-scope="props">{{ props.row.commentaire }}</div>
          <div slot="bic" slot-scope="props">{{ props.row.bic }}</div>

          <div slot="action" slot-scope="props">
            <i class="icon fa fa-trash mr-2" @click="deleteMouvement(props.row.id)"></i>
          </div>


         <div v-if="canManageRpaData()" slot="action" slot-scope="props">
                <b-button
                  type="button"
                  @click.prevent="destroy(props.row.id)"
                  class="badge badge-danger mr-3 p-2"
                >
                  <i class="fa fa-remove"></i> Suppr.
                </b-button>

        </div>

        </v-client-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'
import {espaceRPARules, hasRule} from '../../utils/rulesHelper'

export default {
  data() {
    return {
      rules: espaceRPARules,
      columns: [
        "timestamp",
        "numero_operation",
        "operation",
        "montant",
        "nom_client",
        "libelle",
        "commentaire",
        "bic",
        "action"
      ],
      items: [],
      options: {
        headings: {
          timestamp: "Date",
          numero_operation: "Num. Opé.",
          operation: "Opération",
          montant : "Montant",
          nom_client: "Nom Client",
          libelle: "Libellé",
          commentaire: "Commentaire",
          bic: "BIC"
        },
        sortable: ["timestamp", "numero_operation","operation","nom_client"],
        filterable: ["numero_operation","operation","nom_client","bic","montant"],
        perPage: 30,
        perPageValues: [30, 100, 300],
        texts: {
          filterPlaceholder: "Montant, Client, Opé..."
        }
      },
      excelColumns : [
        {
          label: "Date",
          field: "timestamp",
        },
        {
          label: "Num. Opération",
          field: "numero_operation",
        },
        {
          label: "Opération",
          field: "operation",
        },
        {
          label: "Montant",
          field: "montant",
        },
        {
          label: "Nom Client",
          field: "nom_client",
        },
        {
          label: "Libellé",
          field: "libelle",
        },
        {
          label: "Commentaire",
          field: "commentaire",
        },
        {
          label: "BIC",
          field: "bic",
        },
      ],
      excelData : [],
    }
  },
  mounted() {
   this.all();
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ").replace(/\./g, ",");
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    },
    canManageRpaData() {
      return hasRule(espaceRPARules.MANAGE_RPA_DATA)
    },
    deleteMouvement(id){
      
    },
    all() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceRPA/mouvements")
        .then(response => {
          this.excelData = [];
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.mouvements;
          for(let item of response.data.mouvements) {
            this.excelData.push({
              timestamp: this.formatDate(item.timestamp),
              numero_operation: item.numero_operation && item.numero_operation.trim(),
              operation: item.operation && item.operation.trim(),
              montant: item.montant && this.formatNumber(item.montant),
              nom_client: item.nom_client && item.nom_client.trim(),
              libelle: item.libelle && item.libelle.trim(),
              commentaire: item.commentaire && item.commentaire.trim(),
              bic: item.bic && item.bic.trim(),
              id : item.id
            });
          }
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    destroy(id) {
          let self = this;
          this.$swal
            .fire({
              title: "Êtes-vous sûr?",
              text: "Voulez-vous vraiment supprimer ce Mouvement ?",
              type: "warning",
              reverseButtons: true,
              showCancelButton: true,
              cancelButtonColor: "#ff1744",
              confirmButtonText: "Annuler",
              cancelButtonText: "Supprimer"
            })
            .then(result => {
              if (!result.value) {
                this.$store.commit("IS_LOADING", true);
                this.$axios
                  .post("/espaceRPA/mouvements/delete/" + id)
                  .then(response => {
                    this.$store.commit("IS_LOADING", false);
                    this.$swal({
                      position: "top",
                      type: "success",
                      title: "Suppression avec succès",
                      text: "Le Mouvement a bien été supprimé",
                      showConfirmButton: false,
                      timer: 5000
                    });
                    this.all();
                  })
                  .catch(function(error) {
                    self.$store.commit("IS_LOADING", false);
                    self.$swal({
                      position: "top",
                      type: "warning",
                      title: "Attention !!",
                      text: "Un probléme est survenu, merci de contacter l'administrateur",
                      showConfirmButton: false,
                      timer: 5000
                    });
                  });
              }
            });
        },
  }
}
</script>

<style>
  #tab-mouvements .VueTables__table thead tr th:first-child {
    width: 7%;
  }
  #tab-mouvements .VueTables__table thead tr th:nth-child(2) {
    width: 8%;
  }
  #tab-mouvements .VueTables__table thead tr th:nth-child(3) {
    width: 14%;
  }
  #tab-mouvements .VueTables__table thead tr th:nth-child(4) {
    width: 9%;
  }
  #tab-mouvements .VueTables__table thead tr th:nth-child(5) {
    width: 18%;
  }
  #tab-mouvements .VueTables__table thead tr th:nth-child(6) {
    width: 18%;
  }
  #tab-mouvements .VueTables__table thead tr th:nth-child(7) {
    width: 17%;
  }
  #tab-mouvements .VueTables__table thead tr th:nth-child(8) {
    width: 9%;
  }

  .export-excel-btn {
    background-color: #1e8eb5;
    border-radius: 5px;
    padding: 10px;
    color: #FFFFFF;
    border: none;
  }

</style>
